import React, { createContext, useReducer } from 'react'

export const UPDATE_CHANGE_APPS_DATA = 'UPDATE_CHANGE_APPS_DATA'
export const SET_SELECTED_APPS_DATA = 'SET_SELECTED_APPS_DATA'
export const SHOW_APPS_FORM = 'SHOW_APPS_FORM'
export const SET_APPS_DATA = 'SET_APPS_DATA'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case UPDATE_CHANGE_APPS_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData, showFormPopup: false }
    }
    case SET_SELECTED_APPS_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload?.showFormPopup,
      }
    }
    case SHOW_APPS_FORM: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload.showFormPopup,
      }
    }
    case SET_APPS_DATA: {
      return { ...data, data: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  plants: [],
  selectedObject: {},
  showFormPopup: false,
  data: [],
}

const AppsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <AppsContext.Provider value={[state, dispatch]}>
      {children}
    </AppsContext.Provider>
  )
}

export const AppsContext = createContext(initialState)
export default AppsStore
